module.exports = __webpack_public_path__ + "fonts/dxiconsios.141bd8bb.woff";